import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Button from '../Button';
import { setActiveWorkshop } from '../../actions/app';
import ScheduleIcon from '../../assets/sidebarIcons/Program';
import { UMBRELLA_ACTIVITY_ID } from '../../helpers/constants';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.darkGrey.main,
    fontFamily: 'Avenir Next',
    lineHeight: 1,
    letterSpacing: 1,
  },
  content: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: theme.spacing(),
    gap: theme.spacing(),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
  },
  text: {
    fontSize: 14,
    fontWeight: 500,
    color: theme.palette.darkGrey.main,
    fontFamily: 'Avenir Next',
    lineHeight: 1,
    letterSpacing: 1,
    flex: 1,
    width: '100%',
  },
}));

const SelectYourActivity = ({ setActiveWorkshop: dispatchSetActiveWorkshop }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div className={classes.title}>
        Your activity
      </div>
      <div className={classes.content}>
        <div className={classes.text}>
          Please select your activity in the agenda section on Wednesday afternoon.
        </div>
        <Button
          type="button"
          onClick={() => {
            dispatchSetActiveWorkshop(UMBRELLA_ACTIVITY_ID);
          }}
          variant="primary"
          disabled
          icon={<ScheduleIcon />}
        >
          AGENDA
        </Button>
      </div>
    </div>
  );
};

SelectYourActivity.propTypes = {
  setActiveWorkshop: PropTypes.func.isRequired,
};

export default connect(null, { setActiveWorkshop })(SelectYourActivity);
